import { useNavigate, useParams } from '@tanstack/react-router';
import { RemittanceDetailSlidein } from '@/components/accounts-receivable/remittance-detail/remittance-detail-slidein';

// AR Technical Demo (F1 / GEN-2257): Nami tools are registered one level up on
// RemittancesPage (this route renders inside its <Outlet/>), so the chat panel
// stays active on both the list and the detail. No registrar needed here.
export function RemittanceDetailRoute() {
  const { remittanceId } = useParams({
    from: '/authenticated/accounts-receivable/remittances/$remittanceId',
  });
  const navigate = useNavigate();

  return (
    <>
      <RemittanceDetailSlidein
        remittanceId={remittanceId}
        isOpen
        onOpenChange={(open) => {
          if (!open) {
            navigate({ to: '..', search: true, viewTransition: true });
          }
        }}
      />
    </>
  );
}
